import { updateBetslipWithPushMessage } from 'nike-ui/src/components/betslip/conflicting-bets-dialog/push';

export function mergePushMessage(current, pushMessage) {
    return current.update('betslip', betslip => {
        const updatedBetslip = pushMessage.get('betslip');

        if (updatedBetslip.get('index') === betslip.get('index')) {
            return updateBetslipWithPushMessage(betslip, updatedBetslip);
        }

        return betslip;
    });
}
